import script from "./ApplicationShell.vue?vue&type=script&setup=true&lang=ts"
export * from "./ApplicationShell.vue?vue&type=script&setup=true&lang=ts"

import "./ApplicationShell.vue?vue&type=style&index=0&id=b6c7e036&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b6c7e036"]])

export default __exports__